import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {toApplePayError} from "../models/apple-pay-registration-error";
import {UserService} from '../services/user.service';

@Injectable()
export class ExceptionInterceptor implements HttpInterceptor {

  constructor(private snackBar: MatSnackBar, private userService: UserService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err?.status === 401) {
          this.snackBar.open('Your session has expired. Please sign in again.', 'close', { duration: 5000 });
          this.userService.signOutAndRedirect();
          return throwError(() => err);
        }

        let displayMessage = 'An unknown error occurred';
        const applePayErr = toApplePayError(err?.error);

        if (applePayErr) {
          // Format a user-friendly message using the parsed fields
          displayMessage = `Apple Pay returned ${applePayErr.appleStatusCode} for domain ${applePayErr.domain}: ${applePayErr.errorMessage}`;

          // Log the technical details to the console for developers
          console.error(`[ApplePay Error]:`, applePayErr);
        } else if (err?.status === 412) {
          displayMessage = "Location form is out of date, please refresh the page";
        } else {
          let errMsg = err?.error
          if (typeof errMsg !== 'string' || errMsg.trim().length == 0) {
            errMsg = err?.error?.message || err?.message;
          }

          if (typeof errMsg === 'string' && errMsg.trim().length > 0) {
            displayMessage = errMsg;
          }
        }

        this.snackBar.open(displayMessage, "close", { duration: 5000 });
        return throwError(() => err);
      })
    );
  }
}
